import { fields } from 'iron-forge-react-modules';
import * as dataService from './dataService';



export type INetSuiteEmployee = dataService.INetSuiteEmployee;

export function genComponentAndControllerGenerator() {
  return fields.ObjectSelectField.genComponentAndControllerGenerator({
    useGetObjects: () => dataService.useQuery(),
    fnGetObjectLabel: object => object.displayName
  });
}
